<template>
  <div>
    <div class="row">
      <div class="col-md-4 mb-2" v-show="tieneAlias('Calle')">
        <label>{{ cargarAliasCampo('Calle') }}</label>
        <input
          class="form-control"
          name="calle"
          v-if="tieneOpciones('Calle')"
          :placeholder="cargarAliasCampo('Calle')+' del cliente'"
          @input="actualizarCliente()"
          v-model="localCliente.calle"
        />
        <select
          class="form-select"
          name="calle"
          v-if="!tieneOpciones('Calle')"
          v-model="localCliente.calle"
          @change="actualizarCliente()"
        >
          <option
            v-for="(opcion, index) in cargarOpciones('Calle')"
            :key="`opcion-calle-${index+1}`"
          >
            {{ opcion.nombre }}
          </option>
        </select>
      </div>
      <div class="col-md-4 mb-2" v-show="tieneAlias('N° ext')">
        <label>{{ cargarAliasCampo('N° ext') }}</label>
        <input
          class="form-control"
          name="numero_exterior"
          :placeholder="cargarAliasCampo('N° ext')+' del cliente'"
          v-if="tieneOpciones('N° ext')"
          @input="actualizarCliente()"
          v-model="localCliente.numero_exterior"
        />
        <select
          class="form-select"
          name="numero_exterior"
          v-if="!tieneOpciones('N° ext')"
          @change="actualizarCliente()"
          v-model="localCliente.numero_exterior"
        >
          <option
            v-for="(opcion, index) in cargarOpciones('N° ext')"
            :key="`opcion-numero-exterior-${index+1}`"
          >
            {{ opcion.nombre }}
          </option>
        </select>
      </div>
      <div class="col-md-4 mb-2" v-show="tieneAlias('N° int')">
        <label>{{ cargarAliasCampo('N° int') }}</label>
        <input
          class="form-control"
          name="numero_interior"
          v-if="tieneOpciones('N° int')"
          :placeholder="cargarAliasCampo('N° int')+' del cliente'"
          @input="actualizarCliente()"
          v-model="localCliente.numero_interior"
        />
        <select
          class="form-select"
          name="numero_interior"
          v-if="!tieneOpciones('N° int')"
          @change="actualizarCliente()"
          v-model="localCliente.numero_interior"
        >
          <option
            v-for="(opcion, index) in cargarOpciones('N° int')"
            :key="`opcion-numero-interior-${index+1}`"
          >
            {{ opcion.nombre }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mb-2" v-show="tieneAlias('Colonia')">
        <label>{{ cargarAliasCampo('Colonia') }}</label>
        <input
          class="form-control"
          name="colonia"
          v-if="tieneOpciones('Colonia')"
          :placeholder="cargarAliasCampo('Colonia')+' del cliente'"
          @input="actualizarCliente()"
          v-model="localCliente.colonia"
        />
        <select
          class="form-select"
          name="colonia"
          v-if="!tieneOpciones('Colonia')"
          @change="actualizarCliente()"
          v-model="localCliente.colonia"
        >
          <option
            v-for="(opcion, index) in cargarOpciones('Colonia')"
            :key="`opcion-colonia-${index+1}`"
          >
            {{ opcion.nombre }}
          </option>
        </select>
      </div>
      <div class="col-md-4 mb-2" v-show="tieneAlias('Delegación o Municipio')">
        <label>{{ cargarAliasCampo('Delegación o Municipio') }}</label>
        <input
          class="form-control"
          name="municipio"
          v-if="tieneOpciones('Delegación o Municipio')"
          :placeholder="cargarAliasCampo('Delegación o Municipio')+' del cliente'"
          @input="actualizarCliente()"
          v-model="localCliente.municipio"
        />
        <select
          class="form-select"
          name="municipio"
          v-if="!tieneOpciones('Delegación o Municipio')"
          @change="actualizarCliente()"
          v-model="localCliente.municipio"
        >
          <option
            v-for="(opcion, index) in cargarOpciones('Delegación o Municipio')"
            :key="`opcion-minicipio-${index+1}`"
          >
            {{ opcion.nombre }}
          </option>
        </select>
      </div>
      <div class="col-md-4 mb-2" v-show="tieneAlias('Código postal')">
        <label>{{ cargarAliasCampo('Código postal') }}</label>
        <input
          class="form-control"
          name="codigo_postal"
          :placeholder="cargarAliasCampo('Código postal')+' del cliente'"
          v-if="tieneOpciones('Código postal')"
          @input="actualizarCliente()"
          v-model="localCliente.codigo_postal"
        />
        <select
          class="form-select"
          name="codigo_postal"
          v-if="!tieneOpciones('Código postal')"
          @change="actualizarCliente()"
          v-model="localCliente.codigo_postal"
        >
          <option
            v-for="(opcion, index) in cargarOpciones('Código postal')"
            :key="`opcion-codigo-postal-${index+1}`"
          >
            {{ opcion.nombre }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mb-2" v-show="tieneAlias('Estado de residencia')">
        <label>{{ cargarAliasCampo('Estado de residencia') }}</label>
        <input
          class="form-control"
          name="estado_residencia"
          v-if="tieneOpciones('Estado de residencia')"
          :placeholder="cargarAliasCampo('Estado de residencia')+' del cliente'"
          @input="actualizarCliente()"
          v-model="localCliente.estado_residencia"
        />
        <select
          class="form-select"
          name="estado_residencia"
          v-if="!tieneOpciones('Estado de residencia')"
          @change="actualizarCliente()"
          v-model="localCliente.estado_residencia"
        >
          <option
            v-for="(opcion, index) in cargarOpciones('Estado de residencia')"
            :key="`opcion-estado-residencia-${index+1}`"
          >
            {{ opcion.nombre }}
          </option>
        </select>
      </div>
      <div class="col-md-4 mb-2" v-show="tieneAlias('País')">
        <label>{{ cargarAliasCampo('País') }}</label>
        <input
          class="form-control"
          name="pais"
          v-if="tieneOpciones('País')"
          :placeholder="cargarAliasCampo('País')+' del cliente'"
          @input="actualizarCliente()"
          v-model="localCliente.pais"
        />
        <select
          class="form-select"
          name="pais"
          v-if="!tieneOpciones('País')"
          @change="actualizarCliente()"
          v-model="localCliente.pais"
        >
          <option
            v-for="(opcion, index) in cargarOpciones('País')"
            :key="`opcion-pais-${index+1}`"
          >
            {{ opcion.nombre }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CmpDireccion',
  props: ["cliente", "tieneAlias", "cargarAliasCampo", "tieneOpciones", "cargarOpciones"],
  data() {
    return {
      localCliente: {}
    }
  },
  watch: {
    cliente: {
      deep: true,
      immediate: true,
      handler(val) {
        this.localCliente = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    actualizarCliente: function() {
      var self = this
      self.$emit("update:cliente",  JSON.parse(JSON.stringify(this.localCliente)))
    }
  }
}
</script>

<style scoped>
</style>